import React, { useState } from 'react';

import './CoursesInsurerPolicies.scss';
import { getString } from '../../helpers/styles';
import icons from '../../shared/assets/icons/redesign';

const { Check, Logo } = icons;

export default function CoursesInsurerPolicies({
  insurer = {},
  changeUserData,
  isLogged
}) {
  const [insurerPolicy, setInsurerPolicy] = useState();

  return (
    <div className="courseInsurerPolicies">
      <div className="courseInsurerPolicies-header">
        <Logo />

        <span
          className="courseInsurerPolicies-close-icon"
          onClick={() => (location.href = '/verzekering/cursus-vergoeding')}
        >
          &times;
        </span>
      </div>

      <h3 className="courseInsurerPolicies-title">
        Kies je aanvullende pakket
      </h3>

      <ul className="courseInsurerPolicies-list">
        {(insurer.policies || []).map(({ xuid, name }) => (
          <li
            key={xuid}
            className={getString([
              {
                value: 'courseInsurerPolicies-list-item',
                condition: true
              },
              {
                value: 'courseInsurerPolicies-list-item-active',
                condition: insurerPolicy === xuid
              }
            ])}
            onClick={() => setInsurerPolicy(xuid)}
          >
            <div>
              <img
                alt="insurer-logo"
                src={insurer.logoUrl}
                className="courseInsurerPolicies-insurer-logo"
                width="50"
                height={50}
              />

              <p className="courseInsurerPolicies-insurer-name">{name}</p>
            </div>

            <div className="courseInsurerPolicies-item-checkbox-wrap">
              <span className="courseInsurerPolicies-item-checkmark-wrap">
                <span className="courseInsurerPolicies-item-checkmark">
                  <Check className="courseInsurerPolicies-item-checkmark-icon" />
                </span>
              </span>
            </div>
          </li>
        ))}
      </ul>

      <div className="courseInsurerPolicies-footer">
        <button
          className={getString([
            {
              value: 'courseInsurerPolicies-button',
              condition: true
            },
            {
              value: 'courseInsurerPolicies-button-disabled',
              condition: !insurerPolicy
            }
          ])}
          onClick={async () => {
            if (!insurerPolicy) return;

            if (isLogged)
              await changeUserData({
                variables: { insurerPolicyXuid: insurerPolicy }
              });

            location.href = `/verzekering/cursus-vergoeding/${encodeURIComponent(
              insurer.displayName
            )}?insurerPolicy=${insurerPolicy}`;
          }}
        >
          Verder
        </button>
      </div>
    </div>
  );
}
